import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useTriggerLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { ChatResponder } from "@redotech/redo-model/agents/chat-history";
import { useState } from "react";

export function useAiChat({ returnId }: { returnId: string }) {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const [showChat, setShowChat] = useState(false);

  const [textValue, setTextValue] = useState("");
  const [chatHistory, setChatHistory] = useState<
    { message: string; createdAt: Date; responder: ChatResponder }[]
  >([]);

  const getInitialLoad = useHandler(async () => {
    try {
      const { chatHistory } = await rpcClient.getAiChats({ returnId });
      if (chatHistory.length === 0) {
        setChatHistory([
          {
            createdAt: new Date(),
            message: "Hi there! How can I assist you with this return today?",
            responder: ChatResponder.AI,
          },
        ]);
      } else {
        setChatHistory(chatHistory);
      }
    } catch (e) {
      //TODO: Better error handling in UI/UX
      console.error("AI is currently unavailable", e);
    }
  });

  const [submitLoad, submitTrigger] = useTriggerLoad(async () => {
    const newChat = {
      createdAt: new Date(),
      responder: ChatResponder.MERCHANT,
      message: textValue,
    };
    setChatHistory((prev) => [...prev, newChat]);
    setTextValue("");
    const aiResponse = await rpcClient.getAiChatResponse({
      returnId,
      newChats:
        chatHistory.length === 1 ? [chatHistory[0], newChat] : [newChat],
    });

    setChatHistory(aiResponse.chatHistory);
  });
  const openChat = useHandler(async (value: boolean) => {
    setShowChat(value);
    if (!isTyping && chatHistory.length === 0 && value) {
      setIsTyping(true);

      await getInitialLoad();
      setIsTyping(false);
    }
  });

  const [isTyping, setIsTyping] = useState(false);

  return {
    showChat,
    setShowChat: openChat,
    chatHistory,
    isTyping: isTyping || submitLoad.pending,
    textValue,
    setTextValue,
    submit: () => submitTrigger(),
    suggestions:
      chatHistory.length === 1
        ? [
            "What was the return flow for the customer?",
            "How was the return value calculated?",
            "What is the status of the label?",
          ]
        : undefined,
  };
}
